// modules
import { createAction } from 'redux-actions'

export const setReferralPayerList = createAction('SET_REFERRAL_PAYER_LIST')
